import { AC_GROUP_LIST, AC_GROUP_WITHID, CLEAR_AC_GROUP } from '../../../Helper/actionsTypes';

const ac_groupReducer = (state = [], action) => {
  const { code } = action.payload || ''
  switch (action.type) {
    case AC_GROUP_LIST: {
      return code === 200
        ? { ...state, list: action.payload.results }
        : { ...state, list: [] }
    }
    case AC_GROUP_WITHID: {
      return code === 200
        ? { ...state, details: action.payload.results }
        : { ...state, details: null }
    }
    case CLEAR_AC_GROUP: return {};
    default: return state;
  }
};

export default ac_groupReducer;